export default {
  /**
   * 更新能否下拉刷新
   * @param {*} state
   * @param {*} params
   */
  updateCanPullRefresh (state, params) {
    state.canPullRefresh = params;
  }
};
